import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { shape } from 'prop-types';
import { getProjectMultimedia } from '../../services/mapService';
import Section from '../Section';
import DefaultLoading from '../Loading';
import Notification from '../StoraEnsoComponents/Notification';

const Loading = styled(DefaultLoading)`
  margin: 60px auto;
  justify-content: center;
`;

const ErrorWrapper = styled.div`
  margin: 60px auto;
  max-width: 75%;
`;

function SinglePhotoDetail ({ projectData: { id } }) {
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imgData, setImgData] = useState(null);

  useEffect(() => {
    getProjectMultimedia(id)
      .then(data => setImgData(data))
      .catch(err => setError(err))
      .then(() => setLoading(false));
  }, [id])

  return (
    <Section title="Photo Detail" defaultCollapsedState={false}>
      {
        isLoading && (
          <Loading message="Loading image data..." />
        )
      }

      {
        error && (
          <ErrorWrapper>
              <Notification kind="negative" onClose={() => setError(false)}>An error has occurred while loading image data!</Notification>
          </ErrorWrapper>
        )
      }
      {
        imgData && (
          <img id="singlePhotoImg" src={URL.createObjectURL(imgData)} alt="Photo" />
        )
      }
    </Section>
  );
}

SinglePhotoDetail.propTypes = {
  projectData: shape({}).isRequired,
}

export default SinglePhotoDetail;